export const GET_ORGANIZED_EVENT = "GET_ORGANIZED_EVENT";

export const getOrganizedEvent = event => ({
    type: GET_ORGANIZED_EVENT,
    payload: event
})